// Globals
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize, useForm } from '@/components';
import FaqForm from '../FaqForm/FaqForm';

// Helpers
import { TFaqFormValues } from '../../helpers';

type TCreateFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: TFaqFormValues) => void;
  isLoading?: boolean;
};

const CreateFaqModal: FC<TCreateFaqModalProps> = ({ isOpen, onClose, onSubmit, isLoading }) => {
  const { t } = useTranslation();
  const [formInstance] = useForm();

  useEffect(() => {
    if (isOpen) {
      formInstance.resetFields();
    }
  }, [formInstance, isOpen]);

  return (
    <Modal destroyOnClose title={t('btn_faqs_create')} onCancel={onClose} visible={isOpen} size={ModalSize.LARGE}>
      <FaqForm formInstance={formInstance} onSubmit={onSubmit} onReset={onClose} isLoading={isLoading} />
    </Modal>
  );
};

export default CreateFaqModal;
